export const DEFAULT_PAGE_SIZE = 8;
export const EVENTS_COUNT_WITHOUT_PAGES = 10;
